import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { studentApi } from './journeyApi';

export const JourneyAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
    studentApi('/auth/session', { method: 'POST', body: { session_id: sessionId } })
      .then((user) => navigate(window.location.pathname, { replace: true, state: { user } }))
      .catch(() => navigate(window.location.pathname, { replace: true }));
  }, [location.hash, navigate]);

  return <div className="min-h-screen bg-[#f7f6f2]" data-testid="journey-auth-callback" />;
};
